import { useCallback } from 'react';

import { useNavigate } from 'react-router';

export const useNavigateToLogin = () => {
  const navigate = useNavigate();

  const navigateToLogin = useCallback(
    (returnTo?: string) => {
      const destination = returnTo ?? window.location.pathname + window.location.search;

      void navigate('/login', { state: { returnTo: destination } });
    },
    [navigate]
  );

  return { navigateToLogin };
};
